import React, { useContext } from 'react';
import { DivRow, Input, DropDown } from '../controls';
import { DataContext } from '../../data/DataContext';
import { currency, statusV } from '../../data/MochaData';
import { element, object } from 'prop-types';


const Step2 = () => {

    const { CoopenaeAuto, setCoopenaeAuto, changeHandler } = useContext(DataContext);
    const currencyDefault =  [currency.find((currencyDefault)=> currencyDefault.text === 'Colones')]
    const changeHandlerBrand = (e) => (setCoopenaeAuto({ ...CoopenaeAuto, [e.target.name]: e.target.value, brandName: e.target.desc }));
    const changeHandlerModel = (e) => (setCoopenaeAuto({ ...CoopenaeAuto, [e.target.name]: e.target.value, modelName: e.target.desc }));

    const txtTooltip = 'Es la cantidad de dinero que debe pagar a Seguros LAFISE en caso de sufrir un accidente o una pérdida.';
    const txtTooltip2 = 'Consiste en el valor de mercado de su vehículo, excluyendo equipos especiales';


    return (
        <div className="step-ca">
            <div className="step-container-ca">
                <div className="mt-10">
                    <span className="sub-title-ca text-align: justify">
                        Detalles del vehículo
                </span>
                </div>
                <div className="mt-5 mb-30">
                    <span className="sub-title2-ca text-align: justify">
                        Ingresa los siguientes campos de acuerdo a la documentación de su vehículo
                 </span>
                </div>
                <DivRow>
                    <DropDown label="Moneda de tu póliza*" field="currency" dataProvider={currencyDefault} valueSelect={CoopenaeAuto.currency} onChangeSelect={changeHandler} className="col-ajust" />
                    <DropDown label="Frecuencia de pago*" field="paymentFrequency" dataProvider={CoopenaeAuto.catalogs.paymentFrequency} valueSelect={CoopenaeAuto.paymentFrequency} onChangeSelect={changeHandler} className="col-ajust" />
                </DivRow>
                <DivRow>
                    <DropDown label="Uso del vehículo*" field="vehicleUse" dataProvider={CoopenaeAuto.catalogs.vehicleUse} valueSelect={CoopenaeAuto.vehicleUse} onChangeSelect={changeHandler} className="col-ajust" />
                    <DropDown label="Estado del vehiculo*" field="vehicleStatus" dataProvider={statusV} valueSelect={CoopenaeAuto.vehicleStatus} onChangeSelect={changeHandler} className="col-ajust" />
                </DivRow>
                <DivRow>
                    <DropDown label="Marca*" field="brand" dataProvider={CoopenaeAuto.catalogs.brand} valueSelect={CoopenaeAuto.brand} onChangeSelect={changeHandlerBrand} className="col-ajust" />
                    <DropDown label="Modelo*" field="model" dataProvider={CoopenaeAuto.catalogs.model} valueSelect={CoopenaeAuto.model} onChangeSelect={changeHandlerModel} className="col-ajust" />
                </DivRow>
                <DivRow>
                    <DropDown label="Año*" field="year" dataProvider={CoopenaeAuto.catalogs.year} valueSelect={CoopenaeAuto.year} onChangeSelect={changeHandler} className="col-ajust" />
                    <DropDown label="Deducible*" field="deductible" dataProvider={CoopenaeAuto.catalogs.deductible} valueSelect={CoopenaeAuto.deductible} onChangeSelect={changeHandler} className="col-ajust" useTooltip={true} titleTooltip="Deducible" textTooltip={txtTooltip} />
                </DivRow>
                <DivRow>
                    <Input type="number" label="Valor del vehículo*" field="vehicleValue" value={CoopenaeAuto.vehicleValue} onChange={changeHandler} className="col-ajust" useTooltip={true} titleTooltip="Valor" textTooltip={txtTooltip2} />
                    <DropDown label="Dispositivo*" field="device" dataProvider={CoopenaeAuto.catalogs.device} valueSelect={CoopenaeAuto.device} onChangeSelect={changeHandler} className="col-ajust" />
                </DivRow>

            </div>
        </div>
    )
}

export default Step2;